import React, { ReactElement, ReactNode, useCallback, useEffect } from 'react';
import { useApiDataReducer, ApiDataReducerState } from './ApiDataReducer';
import API from '../../api';
import { useApiAuth } from './useApiAuth';

export type ApiDataValue = ApiDataReducerState;

export const ApiDataContext = React.createContext<ApiDataValue | null>(null);

function ApiDataProvider({ children }: { children: ReactNode }): ReactElement<'div'> | null {
    const authToken = useApiAuth();
    const [state, dispatch] = useApiDataReducer();

    const fetchRegistrationData = useCallback(async () => {
        dispatch({ type: 'GET_REGISTRATION_DATA', phase: 'start' });
        try {
            const data = await API.registration.getClientRegistrationData();
            dispatch({ type: 'GET_REGISTRATION_DATA', phase: 'success', payload: { data } });
        } catch (error) {
            dispatch({ type: 'GET_REGISTRATION_DATA', phase: 'error', error });
        }
    }, [dispatch]);

    useEffect(() => {
        if (authToken) {
            fetchRegistrationData();
        }
    }, [fetchRegistrationData, authToken]);

    return (
        <ApiDataContext.Provider
            value={{
                registrationData: state.registrationData,
            }}
        >
            {children}
        </ApiDataContext.Provider>
    );
}

export { ApiDataProvider };
